import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ContentComponentProps } from '../../../utils/pageBuilder/types';

const isExternalHref = (href: string) => /^(https?:)?\/\//i.test(href);

export function PageBuilderLink({
  children,
  contentType,
  href,
  target,
  'data-pb-style': styleId
}: ContentComponentProps) {
  if (!href || typeof href !== 'string') {
    return null;
  }

  if (isExternalHref(href)) {
    return (
      <a
        href={href}
        target={(target as string) || '_blank'}
        rel="noopener noreferrer"
        className={contentType}
        data-pb-style={styleId as string | undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={href.startsWith('/') ? href : `/${href}`}
      className={contentType}
      data-pb-style={styleId as string | undefined}
    >
      {children}
    </RouterLink>
  );
}
